import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Button, Chip } from "@components/controls/Button"
import { ResultListMode } from "@components/layout/ResultList"
import { RouteFlipped } from "@components/motion/RouteFlipped"
import { IconCaretDown, IconCaretRight, IconCaretUp } from "@components/svg/Icons"
import { getDateRange } from "@utils/dates"
import { Link } from "eddev/routing"
import { useEffect, useMemo, useState } from "react"
import { JudgeCardFragment } from "../../types.graphql"
import { AnimatePresence, motion } from "framer-motion"
import { twMerge } from "tailwind-merge"

type Props = JudgeCardFragment & {
  mode?: ResultListMode
  autoExpand?: boolean
}

export function JudgeCard(props: Props) {
  const info = props.judgeInfo
  const [expanded, setExpanded] = useState(false)

  useEffect(() => {
    if (props.autoExpand) {
      setExpanded(true)
    }
  }, [props.autoExpand])

  const categoryChips = info?.category?.map((cat, i) => (
    <Chip as="span" key={i}>
      {cat?.name}
    </Chip>
  ))
  const yearChip = (
    <Chip as="span" variant="outline">
      {info?.judgeYear}
    </Chip>
  )
  const jobTitle = info?.company ?? info?.position //[info?.position, info?.company].filter(Boolean).map((s, i) => <span key={i}>{s}</span>)
  const image = info?.profileImage && <ResponsiveImage {...info?.profileImage} aspect={4 / 3} />

  if (props.mode === "row") {
    return (
      <div className="@container border-b will-change-transform">
        <button
          className="grid-auto grid-flow-col pt-4 pb-4 text-pretty overflow-clip text-left"
          onClick={() => {
            setExpanded(!expanded)
          }}
        >
          <div className="col-span-8 @3xl:col-span-4">
            <div className="type-title-xs-medium @[200px]:type-title-s-medium antialiased">{props.title}</div>
            <div className="type-title-xs-roman @[200px]:type-title-s-light">{jobTitle}</div>

            {/* Mobile Stats */}
            <div className="@3xl:hidden">
              <div className="flex flex-wrap gap-1 mt-3">
                {yearChip} {categoryChips}
              </div>
            </div>

            {/* Desktop Image */}
            <AnimatePresence>
              {expanded && (
                <motion.div initial={{ opacity: 0, height: 0 }} exit={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} className="hidden @3xl:block">
                  <div className="pt-6">{image}</div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
          <div className="hidden col-span-2 @3xl:block">
            <div className="flex flex-wrap gap-1 pt-1">{categoryChips}</div>
          </div>
          <div className="hidden @3xl:block @3xl:col-span-4">
            <motion.div
              initial="collapsed"
              variants={{ collapsed: { height: "4em" }, expanded: { height: "auto" } }}
              animate={expanded ? "expanded" : "collapsed"}
              className={twMerge("type-body-s-serif el-p:mb-3", expanded ? "" : "[&>p]:hidden [&>p:first-child]:line-clamp-3")}
              dangerouslySetInnerHTML={{ __html: info?.profile ?? "" }}
            />
          </div>
          <div className="hidden @3xl:flex justify-end @3xl:col-span-2">
            {yearChip}
            {expanded ? <IconCaretUp className="w-4 h-4 ml-2" /> : <IconCaretDown className="w-4 h-4 ml-2" />}
          </div>
          {/* Mobile Image */}
          <div className="col-span-4 @3xl:hidden">{image}</div>
        </button>
        <motion.div
          initial="collapsed"
          variants={{ collapsed: { height: "0" }, expanded: { height: "auto" } }}
          animate={expanded ? "expanded" : "collapsed"}
          className="type-body-s-roman el-p:mb-3 overflow-hidden @3xl:!hidden will-change-transform"
        >
          <div className="pt-4 pb-6" dangerouslySetInnerHTML={{ __html: info?.profile ?? "" }} />
        </motion.div>
      </div>
    )
  } else {
    return <div />
    // return (
    //   <div className="block mb-7 @container text-pretty">
    //     <RouteFlipped flipId={props.id!}>
    //       <ResponsiveImage {...props.hero?.image} />
    //     </RouteFlipped>
    //     <div className="stack-y-1 pt-3">
    //       <div className="stack-y-0">
    //         <div className="type-title-xs-medium @[200px]:type-title-s-medium antialiased">{props.title}</div>
    //         <div className="type-title-xs-roman @[200px]:type-title-s-light">{range}</div>
    //       </div>
    //       <div className="flex flex-wrap gap-1">
    //         {props.branches?.nodes.map((branch, i) => (
    //           <Chip key={i}>{branch.shortName}</Chip>
    //         ))}
    //       </div>
    //       <div className="pt-1 type-body-s-roman line-clamp-2">{props.shortDescription}</div>
    //     </div>
    //   </div>
    // )
  }
}
